import { Box, IconButton, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ColorModeContext } from "../../theme";
import { useNavigate } from "react-router-dom";
import {
  getLocalStorageValue,
  removeLocalStorageItem,
} from "../../utils/localStorage";
import { tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminUpdate from "../auth/AdminUpdate";

const DashboardNavbar = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  useEffect(() => {
    const result = getLocalStorageValue("admin");
    setSelectedAdmin(result);
    if (result) setIsUserLoggedIn(true);
  }, []);

  const handleLogoutUser = () => {
    removeLocalStorageItem("admin");
    navigate("/");
  };

  const handleOpenProfileModal = () => setOpenProfileModal(true);
  const handleCloseProfileModal = () => setOpenProfileModal(false);

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      <Box
        width="80%"
        sx={{
          backgroundColor: colors.blueAccent[700],
          color: colors.grey[100],
          fontSize: "14px",
          fontWeight: "bold",
          padding: "10px 20px",
          borderRadius: "5px",
          textAlign: "center",
        }}
      >
        This dashboard show the pages and content in sidebar on the base of user
        access level
      </Box>
      <Box>
        <IconButton type="button" onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "light" ? (
            <LightModeOutlinedIcon />
          ) : (
            <DarkModeOutlinedIcon />
          )}
        </IconButton>

        <IconButton type="button">
          <NotificationsOutlinedIcon />
        </IconButton>

        <IconButton type="button">
          <SettingsOutlinedIcon />
        </IconButton>

        <IconButton type="button" onClick={handleOpenProfileModal}>
          <PersonOutlinedIcon />
        </IconButton>

        {isUserLoggedIn && (
          <IconButton type="button" onClick={handleLogoutUser}>
            <LogoutIcon />
          </IconButton>
        )}

        {openProfileModal && (
          <AdminUpdate
            selectedAdmin={selectedAdmin}
            openModal={openProfileModal}
            handleModalClose={handleCloseProfileModal}
          />
        )}
      </Box>
    </Box>
  );
};

export default DashboardNavbar;
